import LTR from "@brand-icons/ploom/search-full/search-full-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SearchFullIcon = iconFactory("SearchFullIcon", LTR);
